import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import EventInfoSection from './components/EventInfoSection';
import FAQSection from './components/FAQSection';
import PageFooter from './components/PageFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-black" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {/* Fixed navbar */}
      <Navbar />

      {/* Hero */}
      <HeroSection />

      {/* Funnel content */}
      <div
        className="py-6 sm:py-8"
        style={{ background: 'linear-gradient(180deg, #050505 0%, #0a0a0a 50%, #050505 100%)' }}
      >
        {/* Como comparecer */}
        <EventInfoSection />

        {/* FAQ */}
        <FAQSection />
      </div>

      {/* Footer */}
      <PageFooter />
    </div>
  );
}
